var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestProposalComparison(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M30.255 18.065l-3.327-3.326a.97.97 0 0 0-1.347 1.339l1.648 1.648h-6.254a.97.97 0 1 0 0 1.94h6.37l-1.764 1.764a.97.97 0 0 0 0 1.348.97.97 0 0 0 1.347 0l3.327-3.384a.97.97 0 0 0 0-1.338v.01zM27.549 25h-6.38l1.764-1.726a.97.97 0 0 0 0-1.348.97.97 0 0 0-1.348 0l-3.326 3.287a.97.97 0 0 0-.28.67.97.97 0 0 0 .28.678l3.326 3.326a.97.97 0 0 0 1.348-1.348L21.295 26.9h6.254a.97.97 0 1 0 0-1.939v.039zm-9.92 5.062H6.962a1.648 1.648 0 0 1-1.629-1.581V8.873H9.59c1.003 0 1.818-.81 1.823-1.814V2.91h12.131a1.648 1.648 0 0 1 1.668 1.58v6.789a.97.97 0 0 0 1.94 0V4.49A3.55 3.55 0 0 0 23.564.97H10.395a.97.97 0 0 0-.233 0h-.097a1.038 1.038 0 0 0-.271.271l-6.11 6.003a.97.97 0 0 0-.29.766v20.47A3.55 3.55 0 0 0 6.972 32H17.64a.97.97 0 0 0 0-1.94h-.01zM9.503 6.962H6.739l1.406-1.435.194-.184 1.164-1.154v2.773zm9.338 12.073c0-2.269-1.94-3.045-3.607-3.471-2.007-.514-2.143-1.019-2.143-1.62 0-1.144 1.348-1.27 1.94-1.27 1.745 0 1.939.844 1.939.911a.974.974 0 1 0 1.94-.174A3.122 3.122 0 0 0 16 10.84V9.697a.97.97 0 1 0-1.94 0v1.173a3.132 3.132 0 0 0-2.908 3.094c0 2.52 2.53 3.17 3.616 3.49 1.998.514 2.173 1.087 2.173 1.64.011.314-.12.618-.36.824a2.453 2.453 0 0 1-1.57.426c-1.697 0-1.94-.824-1.94-.97a.97.97 0 0 0-1.037-.824.97.97 0 0 0-.882 1.009 3.122 3.122 0 0 0 2.909 2.57v1.144a.97.97 0 1 0 1.939 0v-1.154a3.879 3.879 0 0 0 1.842-.805 2.91 2.91 0 0 0 1-2.279z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestProposalComparison);
export default __webpack_public_path__ + "static/media/request-proposal-comparison.1fd65f5b025863a845bb1970442ad380.svg";
export { ForwardRef as ReactComponent };